import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ParentHeader from "../Parent/ParentHeader/ParentHeader";
import { usePageMeta } from "../Site/useSiteMotion";
import AdjudicatorProfileForm from "./AdjudicatorProfileForm";
import { Bookings } from "./AdjudicatorInvite";
import { errorText, getProfile } from "./adjudicatorApi";
import "../Site/site.css";
import "./adjudicator.css";

// /adjudicator/profile (MC2 card 930d3ac0): a signed-in adjudicator's own
// profile (their photo, with the CLRG directory name and country, on event
// pages and results) and their bookings.
// Bookings split into coming up and past; a past feis or Oireachtas opens its
// results on the judge's own tab (grade exams keep no results).
const startOfToday = () => {
  const now = new Date();
  return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
};
const resultsPath = (b) => {
  const name = String(b.name || "").split(" ").join("+");
  if (b.kind === "feis") return `/results/${name}?id=${b.eventId}&tab=judged`;
  if (b.kind === "oireachtas") return `/oireachtas/results/${name}?id=${b.eventId}&tab=judged`;
  return null;
};
const PastBookings = ({ bookings }) => (
  <ul className="adj-bookings">
    {bookings.map((b) => {
      const to = resultsPath(b);
      return (
        <li key={`${b.kind}-${b.eventId}`} className={to ? "adj-bk-link" : ""}>
          {to ? (
            <Link to={to}>
              <span className="adj-bk-name">{b.name}</span>
              <span className="adj-bk-meta">{[b.day, b.place].filter(Boolean).join(" · ")}</span>
              <span className="adj-bk-go">Your results</span>
            </Link>
          ) : (
            <>
              <span className="adj-bk-name">{b.name}</span>
              <span className="adj-bk-meta">{[b.day, b.place].filter(Boolean).join(" · ")}</span>
            </>
          )}
        </li>
      );
    })}
  </ul>
);

const AdjudicatorProfilePage = () => {
  const [state, setState] = useState({ loading: true });
  usePageMeta("Adjudicator profile", "Your Feis.link adjudicator profile.");

  useEffect(() => {
    let live = true;
    getProfile()
      .then((res) => live && setState({ data: res }))
      .catch((err) => live && setState({ error: errorText(err, "Your adjudicator profile couldn't be loaded.") }));
    return () => { live = false; };
  }, []);

  const { loading, error, data } = state;
  return (
    <div className="site adj">
      <ParentHeader />
      <main>
        <section className="hero adj-hero">
          <div className="wrap">
            <span className="eyebrow">Account</span>
            <h1 className="adj-title">Adjudicator profile</h1>
          </div>
        </section>
        <div className="wrap adj-stack">
          <div className="adj-card">
            {loading && <p className="adj-body">Loading…</p>}
            {error && <p className="adj-error" role="alert">{error}</p>}
            {data && (
              <>
                <p className="adj-body">How you appear on event pages and in results, past results included.</p>
                <AdjudicatorProfileForm initial={data.profile} />
              </>
            )}
          </div>
          {data?.bookings?.length > 0 && (() => {
            const today = startOfToday();
            // a multi-day event is coming up through its last day
            const ends = (b) => b.lastDate || b.date;
            const coming = data.bookings.filter((b) => ends(b) && new Date(ends(b)).getTime() >= today);
            const past = data.bookings.filter((b) => !ends(b) || new Date(ends(b)).getTime() < today).reverse();
            return (
              <>
                {coming.length > 0 && (
                  <div className="adj-card">
                    <h2 className="adj-h2">Coming up</h2>
                    <Bookings bookings={coming} />
                  </div>
                )}
                {past.length > 0 && (
                  <div className="adj-card">
                    <h2 className="adj-h2">Past events</h2>
                    <PastBookings bookings={past} />
                  </div>
                )}
              </>
            );
          })()}
        </div>
      </main>
    </div>
  );
};

export default AdjudicatorProfilePage;
